import React from 'react';
import getCurrencySymbol from '../../../../constants/currencies';


const CalculatedAmountDetail = ({ request, isManager,paymentType }) => (
  <div className="text-center text-success">
    { (request && request.status === 'completed') || isManager
      ? (
        <span
          className="text-success text-success-span"
        >
          <b id="CalculatedAmountDetailAmount">
            {request && request.calculatedAmount.amount}
            {' '}
            {request && request.calculatedAmount.abroadCurrency
              ? getCurrencySymbol(request && request.calculatedAmount.abroadCurrency)
              : '₺'}
          </b>
          {' '}
          {/* eslint-disable-next-line max-len */}
          {request.type === 'domestic' && paymentType.yi === 'Brut' ? 'Brut harcırah ödemesi' : request.type === 'domestic' && paymentType.yi === 'Net' ? 'Net harcırah ödemesi'
          // eslint-disable-next-line max-len
            : request.type === 'abroad' && paymentType.yd === 'Brut' ? 'Brut harcırah ödemesi' : request.type === 'abroad' && paymentType.yd === 'Net' ? 'Net harcırah ödemesi' : null}
          {' '}
          {isManager ? 'alacak.' : 'alacaksınız.'}
          <br />
        </span>
      )
      : <span />
            }

    {
                parseInt(
                  request && request.calculatedAmount.individualAccommodationAmount)
                > 0
                  ? (
                    <span
                      className="text-success text-success-span"
                    >
                      <b id="calculatedAmountDetailIndividualAccommodationAmount">
                        {request && request.calculatedAmount.individualAccommodationAmount}
                        {' '}
                        {request && request.calculatedAmount.abroadCurrency
                          ? getCurrencySymbol(request && request.calculatedAmount.abroadCurrency)
                          : '₺'}
                      </b>
                      {' '}
                      {/* eslint-disable-next-line max-len */}
                      {request.type === 'domestic' && paymentType.ybk === 'Brut' ? 'Brut bireysel konaklama ödemesi' : request.type === 'domestic' && paymentType.ybk === 'Net' ? 'Net bireysel konaklama ödemesi'
                      // eslint-disable-next-line max-len
                        : request.type === 'abroad' && paymentType.ydbk === 'Brut' ? 'Brut bireysel konaklama ödemesi' : request.type === 'abroad' && paymentType.ydbk === 'Net' ? 'Net bireysel konaklama ödemesi' : null}
                      {' '}
                      {isManager ? 'alacak.' : 'alacaksınız.'}
                    </span>
                  )
                  : null
            }
  </div>
);

export default CalculatedAmountDetail;



// WEBPACK FOOTER //
// ./src/components/travel-expense/detail/amount/index.js